import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import { getAppConfigSetting } from '../utils'
import { SENTINEL_API } from './constants'
import queryKeys from '../api/queryKeys'
import { TransferTypes, SearchCashTransfersResponsePayload } from '@Types'

export const buildApiUrl = (accountNumber: string, types?: TransferTypes[]) => {
  const baseUrl = getAppConfigSetting('apiUrl')
  const typesStr = types?.join(',') || ''
  const typesQuery = types && types.length > 0 ? `?type=${typesStr}` : ''
  return `${baseUrl}${SENTINEL_API}/transfers/${accountNumber}${typesQuery}`
}

export default function useGetTransfers(
  accountNumber: string,
  transferTypes?: TransferTypes[],
  params?: Record<string, string>
) {
  const getTransfersUrl = buildApiUrl(accountNumber, transferTypes)
  const getTransfers = async () => {
    const { data } = await axios.get(getTransfersUrl, {
      ...(params && { params }),
      withCredentials: true
    })
    return data as SearchCashTransfersResponsePayload[]
  }

  return useQuery<SearchCashTransfersResponsePayload[], AxiosError>(
    [queryKeys.transfers, accountNumber],
    getTransfers,
    {
      // The query will not execute until the accountNumber exists
      enabled: !!accountNumber
    }
  )
}
